import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _isObject from "lodash/isObject";
import _map from "lodash/map";
import _kebabCase from "lodash/kebabCase";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
var _templateObject;
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import React, { Fragment, useContext, useState } from 'react';
import classNames from 'classnames';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classes from '@nerdwallet/base-styles/classes';
import { gql } from '@nerdwallet/apollo';
import { Li, List, Type } from '@nerdwallet/currency';
import { ControlledAccordion } from '@nerdwallet/react-accordion';
import MarketplaceCta from '@nerdwallet/react-marketplace-cta';
import { APPLY_NOW_LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import OptionalListContent from '../optional-list-content';
import styles from "./keto-product-card.module.css";
import mpcStyles from "../marketplace-product-card.module.css";
import { buildAnalyticsEntityName, sanitizeNode } from '../lib/utils';
import { StructuredContentPropType } from '../lib/constants';
var ItemImpression = function ItemImpression(_ref) {
  var children = _ref.children,
    entityName = _ref.entityName,
    payload = _ref.payload;
  var impressionContext = useContext(ImpressionContext);
  var newPayload = _cloneDeep(payload);
  if (impressionContext !== null && impressionContext !== void 0 && impressionContext.impressionId) {
    _set(newPayload, 'parent_impression_id', impressionContext.impressionId);
  }
  return /*#__PURE__*/React.createElement(Impression, {
    entityName: entityName,
    payload: newPayload
  }, children);
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  ItemImpression.propTypes = {
    children: PropTypes.node,
    entityName: PropTypes.string,
    payload: PropTypes.object // eslint-disable-line react/forbid-prop-types
  };
}

export var KetoAccordionItemWrapper = function KetoAccordionItemWrapper(_ref2) {
  var analyticsEnabled = _ref2.analyticsEnabled,
    children = _ref2.children,
    entityName = _ref2.entityName,
    payload = _ref2.payload;
  if (analyticsEnabled) {
    return /*#__PURE__*/React.createElement(ItemImpression, {
      entityName: entityName,
      payload: payload
    }, children);
  }
  return /*#__PURE__*/React.createElement(Fragment, null, children);
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');
  KetoAccordionItemWrapper.propTypes = {
    analyticsEnabled: _PropTypes.bool,
    children: _PropTypes.node,
    entityName: _PropTypes.string,
    payload: _PropTypes.object // eslint-disable-line react/forbid-prop-types
  };
}

var entityName = 'keto_card_accordion';
var sectionName = 'keto_product_card_more_details';
var entityNamePrefix = "".concat(sectionName, "_");
var BaseOurTake = function BaseOurTake(_ref3) {
  var _analytics$ourTakePro, _analytics$ourTakePro2, _analytics$ourTakePro3;
  var analytics = _ref3.analytics,
    bottomLine = _ref3.bottomLine,
    cons = _ref3.cons,
    enableAnalytics = _ref3.enableAnalytics,
    pros = _ref3.pros;
  var hasBottomLine = !!bottomLine;
  var hasPros = !_isEmpty(pros);
  var hasCons = !_isEmpty(cons);
  if (!hasPros && !hasCons && !hasBottomLine) {
    return null;
  }
  var prosCons = /*#__PURE__*/React.createElement(Fragment, null, hasPros ? /*#__PURE__*/React.createElement(OptionalListContent, {
    content: pros,
    contentLabel: "Pros",
    className: styles.optionalSiblingPadding
  }) : null, hasCons ? /*#__PURE__*/React.createElement(OptionalListContent, {
    content: cons,
    contentLabel: "Cons",
    className: styles.optionalSiblingPadding
  }) : null);
  return /*#__PURE__*/React.createElement(KetoAccordionItemWrapper, {
    analyticsEnabled: !_isEmpty(analytics) || enableAnalytics,
    entityName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro = analytics.ourTakeProps) === null || _analytics$ourTakePro === void 0 ? void 0 : _analytics$ourTakePro.entityName) || "".concat(entityNamePrefix, "our_take_content"),
    payload: {
      element_position: 1,
      section_name: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro2 = analytics.ourTakeProps) === null || _analytics$ourTakePro2 === void 0 ? void 0 : _analytics$ourTakePro2.sectionName) || sectionName,
      section_position: (analytics === null || analytics === void 0 ? void 0 : (_analytics$ourTakePro3 = analytics.ourTakeProps) === null || _analytics$ourTakePro3 === void 0 ? void 0 : _analytics$ourTakePro3.sectionPosition) || 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.accordionContent, styles.accordionContentPadding])
  }, prosCons, hasBottomLine ? /*#__PURE__*/React.createElement("div", {
    className: styles.optionalSiblingPadding
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, "Why We Like It"), bottomLine) : null));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes2 = require('prop-types');
  BaseOurTake.propTypes = {
    analytics: _PropTypes2.shape({
      ourTakeProps: _PropTypes2.shape({
        entityName: _PropTypes2.string,
        sectionName: _PropTypes2.string,
        sectionPosition: _PropTypes2.number
      }),
      /** @deprecated formally used for the accordion */
      payload: _PropTypes2.shape({
        elementName: _PropTypes2.string
      })
    }),
    bottomLine: _PropTypes2.node,
    cons: _PropTypes2.node,
    enableAnalytics: _PropTypes2.bool,
    pros: _PropTypes2.node
  };
}
var BaseKetoAccordion = function BaseKetoAccordion(_ref4) {
  var _analytics$productDet, _analytics$productDet2, _analytics$productDet3;
  var analytics = _ref4.analytics,
    initAccordionItemExpanded = _ref4.initAccordionItemExpanded,
    initOurTakeExpanded = _ref4.initOurTakeExpanded,
    ourTakeContent = _ref4.ourTakeContent,
    productDetails = _ref4.productDetails;
  var _useState = useState([initAccordionItemExpanded, initOurTakeExpanded]),
    _useState2 = _slicedToArray(_useState, 2),
    expandedMap = _useState2[0],
    setExpandedMap = _useState2[1];
  var toggleItem = function toggleItem(index) {
    var newExpandedMap = [false, false];
    newExpandedMap[index] = !expandedMap[index];
    setExpandedMap(newExpandedMap);
  };
  var accordionItems = [{
    children: /*#__PURE__*/React.createElement(KetoAccordionItemWrapper, {
      analyticsEnabled: !_isEmpty(analytics),
      entityName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet = analytics.productDetailsProps) === null || _analytics$productDet === void 0 ? void 0 : _analytics$productDet.entityName) || "".concat(entityNamePrefix, "product_details_content"),
      payload: {
        element_position: 0,
        section_name: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet2 = analytics.productDetailsProps) === null || _analytics$productDet2 === void 0 ? void 0 : _analytics$productDet2.sectionName) || sectionName,
        section_position: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productDet3 = analytics.productDetailsProps) === null || _analytics$productDet3 === void 0 ? void 0 : _analytics$productDet3.sectionPosition) || 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames([styles.accordionContent, styles.accordionContentPadding])
    }, productDetails)),
    expanded: expandedMap[0],
    id: "".concat(entityNamePrefix, "product_details"),
    onSelect: function onSelect() {
      return toggleItem(0);
    },
    key: 'productDetails',
    title: /*#__PURE__*/React.createElement("div", {
      className: classNames([styles.accordionTitle, styles.accordionContentPadding])
    }, "Product Details")
  }, {
    children: ourTakeContent,
    expanded: expandedMap[1],
    id: "".concat(entityNamePrefix, "our_take"),
    onSelect: function onSelect() {
      return toggleItem(1);
    },
    key: 'ourTake',
    title: /*#__PURE__*/React.createElement("div", {
      className: classNames([styles.accordionTitle, styles.accordionContentPadding])
    }, "Our Take")
  }].filter(function (accordionItem) {
    return !!accordionItem.children;
  });
  if (!productDetails) {
    accordionItems = accordionItems.filter(function (accordionItem) {
      return accordionItem.key !== 'productDetails';
    });
  }
  var _ourTakeContent$props = ourTakeContent.props,
    bottomLine = _ourTakeContent$props.bottomLine,
    cons = _ourTakeContent$props.cons,
    pros = _ourTakeContent$props.pros;
  var hasOurTakeContent = !_isEmpty(pros) || !_isEmpty(cons) || !_isNil(bottomLine);
  if (!hasOurTakeContent) {
    accordionItems = accordionItems.filter(function (accordionItem) {
      return accordionItem.key !== 'ourTake';
    });
  }
  if (!accordionItems) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ControlledAccordion, {
    analytics: {
      enabled: !_isEmpty(analytics),
      payload: {
        elementName: buildAnalyticsEntityName(entityName)
      }
    },
    id: "keto_card_accordion",
    items: accordionItems,
    enableTracking: true
  });
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes3 = require('prop-types');
  BaseKetoAccordion.propTypes = {
    analytics: _PropTypes3.shape({
      ourTakeProps: _PropTypes3.shape({
        entityName: _PropTypes3.string,
        sectionName: _PropTypes3.string,
        sectionPosition: _PropTypes3.number
      }),
      productDetailsProps: _PropTypes3.shape({
        entityName: _PropTypes3.string,
        sectionName: _PropTypes3.string,
        sectionPosition: _PropTypes3.number
      })
    }),
    initAccordionItemExpanded: _PropTypes3.bool,
    ourTakeContent: _PropTypes3.node,
    productDetails: _PropTypes3.node
  };
}
export var GqlKetoAccordion = function GqlKetoAccordion(_ref5) {
  var _analytics$productImp, _analytics$productImp2, _analytics$productImp3, _analytics$productImp4;
  var analytics = _ref5.analytics,
    bottomLineOverride = _ref5.bottomLineOverride,
    consOverrides = _ref5.consOverrides,
    ConsRenderer = _ref5.consRenderer,
    gqlMarketplaceEntity = _ref5.gqlMarketplaceEntity,
    initAccordionItemExpanded = _ref5.initAccordionItemExpanded,
    initOurTakeExpanded = _ref5.initOurTakeExpanded,
    prosOverrides = _ref5.prosOverrides,
    ProsRenderer = _ref5.prosRenderer,
    BottomLineRenderer = _ref5.tagLineRenderer;
  var isMonetizing = gqlMarketplaceEntity.isMonetizing,
    marketingBullets = gqlMarketplaceEntity.marketingBullets,
    structuredContentCons = gqlMarketplaceEntity.structuredContentCons,
    structuredContentPros = gqlMarketplaceEntity.structuredContentPros,
    structuredContentTagline = gqlMarketplaceEntity.structuredContentTagline,
    termsAndFeesLink = gqlMarketplaceEntity.termsAndFeesLink;
  var productBullets = marketingBullets;
  var productDetails = !_isEmpty(productBullets) ? /*#__PURE__*/React.createElement(List, null, productBullets.map(function (productDetail) {
    return /*#__PURE__*/React.createElement(Li, {
      key: "product-detail-".concat(_kebabCase(productDetail)),
      className: classes('margin-bottom-2')
    }, sanitizeNode(productDetail, true));
  }), isMonetizing !== false && termsAndFeesLink !== null ? /*#__PURE__*/React.createElement(Li, null, /*#__PURE__*/React.createElement(MarketplaceCta, {
    analyticsPayloadOverrides: {
      sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp = analytics.productImpressionProps) === null || _analytics$productImp === void 0 ? void 0 : (_analytics$productImp2 = _analytics$productImp.payload) === null || _analytics$productImp2 === void 0 ? void 0 : _analytics$productImp2.section_name) || "keto_product_card",
      sectionPosition: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp3 = analytics.productImpressionProps) === null || _analytics$productImp3 === void 0 ? void 0 : (_analytics$productImp4 = _analytics$productImp3.payload) === null || _analytics$productImp4 === void 0 ? void 0 : _analytics$productImp4.section_position
    },
    cta: {
      link: termsAndFeesLink,
      showIcon: false,
      text: 'View Rates and Fees',
      type: 'APPLY_NOW'
    },
    className: mpcStyles.secondaryCta,
    id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
    gqlMarketplaceEntity: gqlMarketplaceEntity
  })) : null) : null;
  var bottomLine = !!bottomLineOverride ? bottomLineOverride : !!structuredContentTagline ? /*#__PURE__*/React.createElement(BottomLineRenderer, null, structuredContentTagline) : null;
  return /*#__PURE__*/React.createElement(BaseKetoAccordion, {
    analytics: analytics,
    initAccordionItemExpanded: initAccordionItemExpanded,
    initOurTakeExpanded: initOurTakeExpanded,
    ourTakeContent: /*#__PURE__*/React.createElement(BaseOurTake, {
      analytics: analytics,
      bottomLine: bottomLine,
      cons: _map(consOverrides !== null && consOverrides !== void 0 ? consOverrides : structuredContentCons, function (con) {
        var _con$props;
        return {
          bullet: ! /*#__PURE__*/React.isValidElement(con) && _isObject(con) ? /*#__PURE__*/React.createElement(ConsRenderer, null, con) : con,
          id: _isObject(con) ? JSON.stringify(con === null || con === void 0 ? void 0 : (_con$props = con.props) === null || _con$props === void 0 ? void 0 : _con$props.children) : con
        };
      }),
      pros: _map(prosOverrides !== null && prosOverrides !== void 0 ? prosOverrides : structuredContentPros, function (pro) {
        var _pro$props;
        return {
          bullet: ! /*#__PURE__*/React.isValidElement(pro) && _isObject(pro) ? /*#__PURE__*/React.createElement(ProsRenderer, null, pro) : pro,
          id: _isObject(pro) ? JSON.stringify(pro === null || pro === void 0 ? void 0 : (_pro$props = pro.props) === null || _pro$props === void 0 ? void 0 : _pro$props.children) : pro
        };
      })
    }),
    productDetails: productDetails
  });
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes4 = require('prop-types');
  GqlKetoAccordion.propTypes = {
    analytics: _PropTypes4.shape({
      ourTakeProps: _PropTypes4.shape({
        entityName: _PropTypes4.string,
        sectionName: _PropTypes4.string,
        sectionPosition: _PropTypes4.number
      }),
      prequalCTATrk: _PropTypes4.string,
      productDetailsProps: _PropTypes4.shape({
        entityName: _PropTypes4.string,
        sectionName: _PropTypes4.string,
        sectionPosition: _PropTypes4.number
      }),
      productImpressionProps: _PropTypes4.shape({
        payload: _PropTypes4.shape({
          section_name: _PropTypes4.string,
          section_position: _PropTypes4.number
        })
      }),
      /** @deprecated formally used for the accordion */
      payload: _PropTypes4.shape({
        elementName: _PropTypes4.string
      })
    }),
    bottomLineOverride: _PropTypes4.node,
    consOverrides: _PropTypes4.arrayOf(_PropTypes4.node),
    gqlMarketplaceEntity: _PropTypes4.shape({
      isMonetizing: _PropTypes4.bool,
      marketingBullets: _PropTypes4.arrayOf(_PropTypes4.string),
      termsAndFeesLink: _PropTypes4.string,
      termsAndFeesRedirectLink: _PropTypes4.string,
      structuredContentCons: StructuredContentPropType,
      structuredContentPros: StructuredContentPropType,
      structuredContentTagline: StructuredContentPropType
    }),
    initAccordionItemExpanded: _PropTypes4.bool,
    initOurTakeExpanded: _PropTypes4.bool,
    prosOverrides: _PropTypes4.arrayOf(_PropTypes4.node)
  };
}
GqlKetoAccordion.defaultProps = {
  analytics: {},
  initAccordionItemExpanded: false,
  initOurTakeExpanded: false
};
GqlKetoAccordion.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment GqlKetoAccordion on MarketplaceEntityInterface {\n    ... on MarketplaceOfferInterface {\n      isMonetizing\n    }\n    ... on CreditCardsOfferV2 {\n      marketingBullets\n      termsAndFeesLink\n    }\n    ... on MarketplaceEntityWithPlacementInterface {\n      structuredContentCons\n      structuredContentPros\n      structuredContentTagline\n    }\n  }\n"])));
var KetoAccordion = function KetoAccordion(_ref6) {
  var analytics = _ref6.analytics,
    bottomLine = _ref6.bottomLine,
    cons = _ref6.cons,
    enableAnalytics = _ref6.enableAnalytics,
    initAccordionItemExpanded = _ref6.initAccordionItemExpanded,
    initOurTakeExpanded = _ref6.initOurTakeExpanded,
    productDetails = _ref6.productDetails,
    pros = _ref6.pros;
  useDeprecatedPropsWarning({
    component: 'KetoAccordion',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  return /*#__PURE__*/React.createElement(BaseKetoAccordion, {
    analytics: analytics,
    initAccordionItemExpanded: initAccordionItemExpanded,
    initOurTakeExpanded: initOurTakeExpanded,
    ourTakeContent: /*#__PURE__*/React.createElement(BaseOurTake, {
      analytics: analytics,
      bottomLine: bottomLine,
      cons: cons,
      enableAnalytics: enableAnalytics,
      pros: pros
    }),
    productDetails: productDetails
  });
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes5 = require('prop-types');
  KetoAccordion.propTypes = {
    bottomLine: _PropTypes5.node,
    cons: _PropTypes5.node,
    initAccordionItemExpanded: _PropTypes5.bool,
    initOurTakeExpanded: _PropTypes5.bool,
    ourTakeContentOverride: _PropTypes5.shape({
      hasCons: _PropTypes5.bool,
      hasPros: _PropTypes5.bool,
      hasBottomLine: _PropTypes5.bool,
      ourTakeContent: _PropTypes5.node
    }),
    productDetails: _PropTypes5.node,
    pros: _PropTypes5.node,
    enableAnalytics: _PropTypes5.bool,
    analytics: _PropTypes5.shape({
      ourTakeProps: _PropTypes5.shape({
        entityName: _PropTypes5.string,
        sectionName: _PropTypes5.string,
        sectionPosition: _PropTypes5.number
      }),
      productDetailsProps: _PropTypes5.shape({
        entityName: _PropTypes5.string,
        sectionName: _PropTypes5.string,
        sectionPosition: _PropTypes5.number
      }),
      /** @deprecated formally used for the accordion */
      payload: _PropTypes5.shape({
        elementName: _PropTypes5.string
      })
    })
  };
}
KetoAccordion.defaultProps = {
  analytics: {},
  initAccordionItemExpanded: false,
  initOurTakeExpanded: false,
  ourTakeContentOverride: {}
};
export default KetoAccordion;